"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
* Manage king of the hill
* @extends SoulModule
*/


var Koth =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Koth, _SoulModule);

  function Koth() {
    _classCallCheck(this, Koth);

    return _possibleConstructorReturn(this, _getPrototypeOf(Koth).apply(this, arguments));
  }

  _createClass(Koth, [{
    key: "getFeed",

    /**
    * get current king of the hill
    * @param {Object} params
    * User location with optional radius value
    * @param {string} params.location_with_radius
    * Optional city id
    * @param {string} params.city_id
    * Looking for genders
    * @param {string} params.looking_for
    * Looking for sexualities
    * @param {string} params.sexuality
    * User locale
    * @param {string} params.lang
    * @soulsdk soul.koth.getFeed
    * @example soul.koth.getFeed({
    *   location_with_radius: '50.08,14.505,5',
    *   looking_for: 'm,f',
    *   sexuality: 'h',
    *   lang: 'ru',
    * })
    */
    value: function getFeed(params) {
      return this.api.get('koth/feed/', params);
    }
    /**
    * get user kings of the hill
    * @soulsdk soul.koth.getMy
    * @example soul.koth.getMy()
    */

  }, {
    key: "getMy",
    value: function getMy() {
      return this.api.get('koth/my/');
    }
    /**
    * get koth views
    * Koth id
    * @param {string} id
    * @soulsdk soul.koth.getKothViews
    * @example soul.koth.getKothViews(id)
    */

  }, {
    key: "getKothViews",
    value: function getKothViews(id) {
      return this.api.get("koth/views_count/".concat(id, "/"));
    }
  }]);

  return Koth;
}(SoulModule);

module.exports = Koth;